import { RadioCore } from '../shared/components/Radio.mjs';
import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';

const Radio = styled(RadioCore)(({ theme })=>({
        color: theme.styleConfig.colors.primary
    }));

export { Radio };
//# sourceMappingURL=Radio.mjs.map
